



























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Button from "@/shared/components/ui/Button.vue";
import * as SharedRoutes from "@/shared/route-names";
import { formatMMddyyyyDateString } from "@/shared/dateString";
import { useUserInvestmentAccountStore } from "@/shared/store/userInvestmentAccount";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { DrivewealthAccount } from "@/shared/types";

interface InvestmentTableItem {
  custodian: string;
  accountNumber: string;
  accountStatus: string;
  dateAccountClosed?: string;
  accountId?: number;
}

@Component({
  components: {
    GenericLoadingSpinner,
    Button
  }
})
export default class AccountHolderInvestment extends Vue {
  userInvestmentAccountStore = useUserInvestmentAccountStore();
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  SharedRoutes = SharedRoutes;
  formatMMddyyyyDateString = formatMMddyyyyDateString;

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  mounted () {
    const args = { username: this.username, partnerId: this.partnerId };
    this.userInvestmentAccountStore.loadInvestmentAccount(args);
    this.drivewealthStore.loadAccounts(args);
    this.drivewealthSweepStore.getSweep(args);
  }

  get isLoaded () {
    return this.drivewealthStore.accountsLoaded;
  }

  get displayTDAInvestmentAccount () {
    return this.userInvestmentAccountStore.investmentAccountNumber !== undefined;
  }

  /**
   * combine both TDA and drivewealth accounts for display
   */
  get accounts (): InvestmentTableItem[] {
    const allAccounts: InvestmentTableItem[] = [];
    if (this.drivewealthStore.accounts.items) {
      for (const dwAccount of this.drivewealthStore.accounts.items) {
        allAccounts.push(this.mapDriveWealthAccount(dwAccount));
      }
    }

    if (this.displayTDAInvestmentAccount) {
      allAccounts.push(this.mapTdaAccount());
    }
    return allAccounts;
  }

  mapDriveWealthAccount (dwAccount: DrivewealthAccount): InvestmentTableItem {
    return {
      custodian: "DriveWealth",
      accountNumber: dwAccount.accountNumber,
      accountStatus: dwAccount.accountStatus,
      dateAccountClosed: dwAccount.dateAccountClosed,
      accountId: dwAccount.drivewealthAccountId
    };
  }

  mapTdaAccount (): InvestmentTableItem {
    return {
      custodian: "TDA",
      accountNumber: this.userInvestmentAccountStore.investmentAccountNumber,
      accountStatus: this.userInvestmentAccountStore.investmentAccountActive ? "open" : "closed"
    };
  }

  routeToInvestmentAccountDetail (dwAccountId: number) {
    const query = (this.username) ? { username: this.username } : undefined;
    const route = {
      name: SharedRoutes.DrivewealthInvestmentAccountV2,
      params: { accountId: `${dwAccountId}`, partnerId: `${this.partnerId}` },
      query
    };
    this.$router.push(route);
  }

  isOpen (accountStatus: string) {
    return accountStatus && accountStatus.toLowerCase().includes("open");
  }

  isClosed (accountStatus: string) {
    return accountStatus && accountStatus.toLowerCase().includes("closed");
  }

  disableSweep (): void {
    const args = { username: this.username, partnerId: this.partnerId };
    this.drivewealthSweepStore.pauseSweepEmployerManagement(args);
  }
}
